var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscounts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M4.802 2.46a1.6 1.6 0 0 0-.792 1.55 1.6 1.6 0 0 0-1.462 2.53 1.6 1.6 0 0 0 0 2.923 1.6 1.6 0 0 0 1.462 2.53 1.6 1.6 0 0 0 2.53 1.462 1.6 1.6 0 0 0 2.923 0 1.6 1.6 0 0 0 2.53-1.461 1.6 1.6 0 0 0 1.461-2.531 1.6 1.6 0 0 0 0-2.923 1.6 1.6 0 0 0-1.46-2.53 1.6 1.6 0 0 0-2.531-1.461 1.6 1.6 0 0 0-2.923 0 1.6 1.6 0 0 0-1.738-.09m5.465 3.585a.8.8 0 0 0-1.331-.887l-3.2 4.8a.8.8 0 0 0 1.331.887zM5.602 7.202a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m5.6 2.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0",
  clipRule: "evenodd"
})));
export default SvgDiscounts;